import React from "react";
import Homenewajpv2 from "./Homenewajpv2";
import { getAjpRoutePlannerPage } from "../data/ajpRoutePlannerPages";

export default function AjpRoutePlannerPage({ pageKey }) {
  const page = getAjpRoutePlannerPage(pageKey);
  return page ? <Homenewajpv2 pageConfig={page} /> : null;
}
